/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Videos_FailedInputs */

const cs_videos_failed = /** @type {(inputs: Videos_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrání videa se nezdařilo`)
};

const en_videos_failed = /** @type {(inputs: Videos_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video upload failed`)
};

/**
* | output |
* | --- |
* | "Video upload failed" |
*
* @param {Videos_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const videos_failed = /** @type {((inputs?: Videos_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Videos_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_videos_failed(inputs)
	return cs_videos_failed(inputs)
});